<template>
    <a href="/">
        <img id="logo" src="@/assets/images/logo.png" />
    </a>
</template>

<script>
export default {
    name: "logo-img"
};
</script>

<style scoped>
#logo {
    width: 228px;
    height: 53px;
    margin-top: 20px;
}
</style>
